export class InputBase<T>{
    value:string;
    key:string;
    label:string;
    required:boolean;
    controlType:string;
    disabled:boolean;
    type:string = "";
    options:{key:string, value:string}[]=[]

    constructor(options:{
        value?:string,
        key?:string,
        label?:string,
        required?:boolean,
        controlType?:string,
        disabled?:boolean
    }={}){
        this.value =  options.value === undefined ? "" : options.value;
        this.key = options.key || '';
        this.label = options.label || '';
        this.required = !!options.required;
        this.controlType = options.controlType || '';
        this.disabled = options.disabled || false ;
    }

}